var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2875 9.26298L17.7625 6.78797C18.8104 5.83288 20.186 5.31827 21.6034 5.35109C23.0209 5.3839 24.3712 5.96162 25.3738 6.96418C26.3763 7.96675 26.9541 9.31706 26.9869 10.7345C27.0197 12.152 26.5051 13.5276 25.55 14.5755L22.0125 18.1005C21.5027 18.6122 20.8968 19.0183 20.2297 19.2953C19.5626 19.5724 18.8473 19.715 18.125 19.715C17.4026 19.715 16.6874 19.5724 16.0203 19.2953C15.3532 19.0183 14.7473 18.6122 14.2375 18.1005",
    stroke: "#CACBCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7125 23.413L14.2375 25.888C13.1896 26.843 11.814 27.3577 10.3966 27.3248C8.97911 27.292 7.6288 26.7143 6.62623 25.7117C5.62367 24.7092 5.04595 23.3589 5.01314 21.9414C4.98032 20.5239 5.49493 19.1483 6.45002 18.1005L9.98752 14.5755C10.4974 14.0637 11.1032 13.6577 11.7703 13.3806C12.4374 13.1036 13.1527 12.9609 13.875 12.9609C14.5974 12.9609 15.3126 13.1036 15.9797 13.3806C16.6469 13.6577 17.2527 14.0637 17.7625 14.5755",
    stroke: "#CACBCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIco);
export default __webpack_public_path__ + "static/media/link_ico.7d3c616d6113af7f4568ce6cc38c43c0.svg";
export { ForwardRef as ReactComponent };